"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zIndexPopover = exports.zIndexModal = exports.zIndexNavigation = exports.zIndexTooltip = exports.zIndexDropdown = exports.zIndexWindow = exports.zIndexOverlay = exports.zIndexSurface = void 0;
exports.zIndexSurface = 1;
exports.zIndexOverlay = 5;
exports.zIndexWindow = 10;
exports.zIndexDropdown = 20;
exports.zIndexTooltip = 30;
exports.zIndexNavigation = 40;
exports.zIndexModal = 50;
exports.zIndexPopover = 60;